import React, { useState } from 'react';
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Modal,
  Paper,
  Switch,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const LeadsQueueModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [queueTab, setQueueTab] = useState(0);
  const [autoAccept, setAutoAccept] = useState(false);
  const [autoRedirect, setAutoRedirect] = useState(false);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Paper
        sx={{
          width: '90%',
          maxWidth: 500,
          maxHeight: '90vh',
          overflow: 'auto',
          borderRadius: 2,
          p: 3,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          {t('leads.queueManagement')}
        </Typography>

        <Tabs value={queueTab} onChange={(e, v) => setQueueTab(v)} sx={{ mb: 3 }}>
          <Tab label={t('leads.automatic')} />
          <Tab label={t('leads.manual')} />
        </Tabs>

        {queueTab === 0 && (
          <Box>
            <Box sx={{ mb: 3 }}>
              <FormControlLabel
                control={<Switch checked={autoAccept} onChange={(e) => setAutoAccept(e.target.checked)} />}
                label={
                  <Box>
                    <Typography variant="subtitle2">
                      {t('leads.autoAccept')}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {t('leads.autoAcceptDesc')}
                    </Typography>
                  </Box>
                }
              />
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ mb: 3 }}>
              <FormControlLabel
                control={<Switch checked={autoRedirect} onChange={(e) => setAutoRedirect(e.target.checked)} />}
                label={
                  <Box>
                    <Typography variant="subtitle2">
                      {t('leads.autoRedirect')}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {t('leads.autoRedirectDesc')}
                    </Typography>
                  </Box>
                }
              />
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                {t('leads.businessHours')}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {t('leads.businessHoursDesc')}
              </Typography>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <InfoIcon color="primary" fontSize="small" />
                <Typography variant="subtitle2" color="primary">
                  {t('leads.roundRobinMode')}
                </Typography>
              </Box>
              <Typography variant="caption" color="text.secondary">
                {t('leads.roundRobinDesc')}
              </Typography>
            </Box>
          </Box>
        )}

        {queueTab === 1 && (
          <Box>
            <Typography variant="body2" color="text.secondary">
              {t('leads.manualModeDesc')}
            </Typography>
          </Box>
        )}

        <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
          <Button variant="outlined" fullWidth onClick={onClose}>
            {t('leads.cancel')}
          </Button>
          <Button
            variant="contained"
            fullWidth
            onClick={onClose}
          >
            {t('leads.save')}
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

export default LeadsQueueModal;
